import { FontIcon } from '../FontIcon';
import { LinkProps, LinkWrapper } from '../LinkWrapper';
import { Skeleton } from '../Skeleton';
import styles from './rwprogress.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    current?: number; // Optional when loading
    total?: number;
    showInfo?: (e: React.MouseEvent) => void;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    current: number; // Required when not loading
    total: number;
    showInfo?: (e: React.MouseEvent) => void;
}

export type RewardProgressProps = LoadingProps | LoadedProps;

export const RewardProgress = ({ current, total, showInfo, isLoading, ...props }: RewardProgressProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.rwprogress, props.className)}>
                <Skeleton absolute />
            </div>
        );
    }

    const progressPercent = Math.floor((current / total) * 100);

    return (
        <div {...props} className={cn(styles.rwprogress, props.className)}>
            <div className={styles.points}>
                <strong className={styles.percentage}>
                    <b>{progressPercent}</b> %
                </strong>
                <div className={styles.values}>
                    <b>{Intl.NumberFormat('en-US').format(current)}</b> / {Intl.NumberFormat('en-US').format(total)}{' '}
                    {showInfo && (
                        <div onClick={showInfo} className={styles.info}>
                            <FontIcon name="info" size="x-small" md="x-small" />
                        </div>
                    )}
                </div>
            </div>
            <div className={styles.progress} data-test-id="reward-balance-progress">
                <span style={{ width: `${progressPercent}%` }}></span>
            </div>
        </div>
    );
};
